/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
/**
 * `entities/tracker-automation` TanStack Query key factory. `all` for
 * namespace invalidation, `list(trackerId)` for one board's rules (ordered by
 * position, as the backend emits); `runsOf(trackerId)` for every history view
 * of one board.
 */
export const TRACKER_AUTOMATION_QUERY_KEYS = {
  all: ['tracker-automations'] as const,
  list: (trackerId: string) => [...TRACKER_AUTOMATION_QUERY_KEYS.all, 'list', trackerId] as const,
  preview: (trackerId: string, draft: unknown) =>
    [...TRACKER_AUTOMATION_QUERY_KEYS.all, 'preview', trackerId, draft] as const,
  previewRows: (trackerId: string, search: string) =>
    [...TRACKER_AUTOMATION_QUERY_KEYS.all, 'preview-rows', trackerId, search] as const,
  runsOf: (trackerId: string) => [...TRACKER_AUTOMATION_QUERY_KEYS.all, 'runs', trackerId] as const,
  runs: (trackerId: string, filter: { automationId?: string; rowRef?: string }) =>
    [...TRACKER_AUTOMATION_QUERY_KEYS.runsOf(trackerId), filter] as const,
  aiBudget: (workspaceId: string | null) =>
    [...TRACKER_AUTOMATION_QUERY_KEYS.all, 'ai-budget', workspaceId] as const,
  aiCapabilities: (workspaceId: string | null) =>
    [...TRACKER_AUTOMATION_QUERY_KEYS.all, 'ai-capabilities', workspaceId] as const,
  availableAgents: (workspaceId: string | null) =>
    [...TRACKER_AUTOMATION_QUERY_KEYS.all, 'available-agents', workspaceId] as const,
  suggestions: (trackerId: string) =>
    [...TRACKER_AUTOMATION_QUERY_KEYS.all, 'suggestions', trackerId] as const,
} as const;
